<template>
    <div>
        <p>Change the risk score by {{action.score}} points.</p>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'add-risk-score-summary',
        extends: BaseActionSummary,
    };
</script>

<style scoped>

</style>
